export interface AppPathwayBundleFlags {
  /** SFS console, consultancy, and non–client-org auditor routes. */
  loadSfsPathway: boolean;
  /** Client org operations (work, checklists, documents, events, etc.). */
  loadClientPathway: boolean;
  /** Shared pages (/client-home, /reports/*, /admin-settings) for client and SFS roles. */
  loadReportingPathway: boolean;
}

interface PathwayRoleInput {
  authenticated: boolean;
  isSfsAdmin: boolean;
  isConsultantManager: boolean;
  isAuditor: boolean;
  isAuditorInClientOrg: boolean;
  isClient: boolean;
}

/**
 * Decides which lazy route pathway chunks may be mounted after Clerk auth resolves.
 * Pure clients never mount the SFS pathway switch (they do not download SFS page chunks).
 * PreloadRouteBundles prefetches the mounted pathways in the background after first paint.
 */
export function resolveAppPathwayBundles(input: PathwayRoleInput): AppPathwayBundleFlags {
  // Mount protected route shells before auth resolves so deep links redirect to /login
  // instead of 404. Page chunks still lazy-load only after ProtectedRoute authorizes.
  if (!input.authenticated) {
    return { loadSfsPathway: true, loadClientPathway: true, loadReportingPathway: true };
  }

  const loadSfsPathway =
    input.isSfsAdmin ||
    input.isConsultantManager ||
    (input.isAuditor && !input.isAuditorInClientOrg);

  const loadClientPathway =
    input.isClient || input.isAuditorInClientOrg || input.isSfsAdmin || input.isConsultantManager;

  return {
    loadSfsPathway,
    loadClientPathway,
    loadReportingPathway: loadSfsPathway || loadClientPathway,
  };
}
